import { t } from 'utilities/TranslationUtils';
import { observer } from 'mobx-react-lite';

// components
import { AppButton } from 'components/form';

type IProps = {
  onInviteUser: () => void;
  onAddDirectly: () => void;
  isAddingUser: boolean;
  isInvitingUser: boolean;
  isAddingDirectlyDisabled: boolean;
};
export const InviteUserStep = observer(
  ({ onInviteUser, onAddDirectly, isInvitingUser, isAddingUser, isAddingDirectlyDisabled }: IProps) => {
    return (
      <section className='row text-center'>
        <>
          <div className=' col-6'>
            <div className='card d-flex justify-content-end pt-3'>
              <p>{t('usersPage.sendInvitationDescription')}</p>

              <AppButton
                variant='primary'
                onClick={() => onInviteUser()}
                data-test='user-dialog-send-invitation-button'
                disabled={isInvitingUser || isAddingUser}
              >
                {isInvitingUser ? `${t('usersPage.sendingInvitation')}...` : t('usersPage.sendInvitation')}
              </AppButton>
            </div>
          </div>
          <div className=' col-6'>
            <div className='card d-flex justify-content-end pt-3'>
              <p>{t('usersPage.addUserDirectlyDescription')}</p>
              <AppButton
                variant='primary'
                onClick={() => onAddDirectly()}
                data-test='user-dialog-add-user-directly-button'
                disabled={true || isInvitingUser || isAddingUser || isAddingDirectlyDisabled}
              >
                {isAddingUser ? `${t('usersPage.addingUser')}...` : t('usersPage.addUserDirectly')}
              </AppButton>
            </div>
          </div>
        </>
        {/* )} */}
      </section>
    );
  }
);

export default InviteUserStep;
